export default "__VITE_ASSET__BLZI$5IZ__"